export default __webpack_public_path__ + "static/media/kubernetes.f91022b1.svg";